export default __webpack_public_path__ + "static/media/Datum_500.dd74fcf1.png";